var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftNarrow = function SvgArrowLeftNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.06 17.06a1.5 1.5 0 0 1-2.12 0l-4-4a1.5 1.5 0 0 1-.19-.23l-.019-.031a1.5 1.5 0 0 1-.117-.228l-.019-.05q-.016-.042-.03-.085a2 2 0 0 1-.036-.145 1.5 1.5 0 0 1 0-.583l.017-.072.019-.07q.014-.045.03-.087l.019-.05a1.5 1.5 0 0 1 .117-.227l.019-.03q.082-.127.19-.232l4-4a1.5 1.5 0 0 1 2.12 2.12L6.62 10.5H21a1.5 1.5 0 0 1 0 3H6.62l1.44 1.44a1.5 1.5 0 0 1 0 2.12"
  })));
};
export default SvgArrowLeftNarrow;